module.exports = {
    inViewEventName: 'phoenix:flatGallery:slide:inView',
    outOfViewEventName: 'phoenix:flatGallery:slide:outOfView',
};
